<app-header></app-header>
<section class="container-xxl">
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>
    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                      </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                        <!-- INNER CONTENT - STARTS -->

    <div class="inner-page-sidedetails">
        <div id="section-New"></div>
        <div class="inner-banner-image">
            <div class="image-area">
                <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
            </div>
        </div>
        <div class="details">
            <div class="title">
                <h2 class="screen-reader">{{ 'Handbook' | translate }}</h2>
            </div>
            <div class="description">
                <div class="handbook mt-3 mb-5">
                    <div class="row grid grid-cols-1 sm:grid-cols-6 gap-6 md:gap-8">
                        <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" *ngFor="let item of handbookList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">
        
                            <div class="handbook">
                                <div class="handbook-image">
 
                                    
                                    <img [src]="checkImageFile(item)?backend_url+'storage/app/uploads/'+item.image:envData.siteURL+'assets/images/gray-abstract-book.jpg'" alt="Handbook Image" class="img-fluid screen-reader">

                                </div>
        
                                <div class="handbook-text">
                                  
                                    <h5 class="fw-bold screen-reader">{{ language=='English'?item.titleInEnglish:item.titleInHindi  }}</h5>
                                    <p class="shot-des font-adjust screen-reader">{{ language=='English'?item.descriptionInEnglish:item.descriptionInHindi}}</p>
        
        
                                    <div class="d-flex align-items-center justify-content-between">
        
                                        <div class="mag-dt screen-reader">
                                            <i class="bi bi-calendar me-2"></i>
                                            {{ item.date | date: 'MMM d, y'}}
                                        </div>
                                        
                                        <div *ngIf="checkFileExists(item)">
                                                <div class="opening-date " *ngIf="item.documents_details.fileSize!==''">
                                                    <strong class="d-block screen-reader">
                                                      <a [href]="backend_url+'storage/app/uploads/'+item.documents" [download]="item.documents" target="_blank" [attr.title]="language=='English'?'Download File':'डाउनलोड फ़ाइल'" class="text-success"><span class="me-2"> <i
                                                            class="bi bi-download me-1"></i> {{ 'Download'|translate }}</span></a>
                                                    </strong>
                                                    <span class="labels text-muted screen-reader">
                                                        ({{ item.documents_details.fileSize }} <span style="text-transform: uppercase;" *ngIf="checkFileType(item)!==false" [innerHtml]="checkFileType(item).file"></span>) 
                                                    </span>
                                                  </div>
                                        </div>
        
                                    </div>
                                </div>
                            </div>
        
        
        
                        </div>
        
         
                         
        
                    </div>
                    <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 18"></pagination-controls>
                </div>
            </div>

        </div>
    </div>
</div>


</div>
</div>
</div>


</section>

<app-clients></app-clients>

<app-footer></app-footer>